import React from 'react';
import {useIntl} from 'react-intl';
import {useHeader} from '../../_metronic/layout';
import {useSubheader} from '../../_metronic/layout';
import AgentsIncomesPage from '../modules/AgnetsIncomes/AgentsIncomesPage';

export function AgentsInvoices() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: 'agents-invoices-page-title',
    defaultMessage: 'Agents Invoices'
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName('subheader-custom-height');
  subheader.setDisplaySubheader(false);

  return <AgentsIncomesPage/>;
}
